import React, { useEffect, useState } from 'react';
import { Button } from 'semantic-ui-react';
import { scrollToSection } from '../../utils/scroll-to-section';
import { ExpandCircle } from '../../assets/icons/ExpandCircle';
import styles from './styles.module.scss';

export const ManualScrollToTop = ({ elementRef }) => {

  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const element = elementRef.current;
    if (!element) return undefined;

    const handleScroll = () => {
      setIsVisible(element.scrollTop > 0);
    };

    handleScroll();
    element.addEventListener('scroll', handleScroll);

    return () => element.removeEventListener('scroll', handleScroll);
  }, [elementRef]);

  if (!isVisible) return null;

  return (
    <div className={styles.containerScrollToTop}>
      <Button
        icon={<ExpandCircle />}
        onClick={() => scrollToSection(elementRef)}
        className={styles.buttonScrollToTop}
      />
    </div>
  );
};
